import { erpApi } from "@/shared/axios";
import { useMutation } from "@tanstack/react-query";
import { urlBackendSoftnet, urlBackend } from '@/shared/constants/networking.constants';

const { post } = erpApi();

/**
 * Hook mutation para obtener reporte de contratos pendientes
 */
export const useObtenerReportesContratosSoftnet = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackendSoftnet}/api/reportes-contratos`,
        params,
        true
      );
      return resp;
    },
  });
};

/**
 * Hook mutation para obtener reporte de contratos pendientes
 */
export const useObtenerReportesContratosGolondrinas = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackend}api/v1/obtener-reporte-golondrinas/`,
        params,
        true
      );
      return resp;
    },
  });
};
